/**
 * ServiceTypeLegend — legend for tree color dots (only shows types present in
 * the tree). Moved out of ServiceManagementPage.tsx (KAN-157 god-component
 * split).
 */
import { METHOD_LABELS, METHOD_ORDER } from '@/utils/serviceFormula';
import { ServiceTypeMarker } from './ServiceTypeMarker';

export function ServiceTypeLegend({ methods }: { methods: string[] }): JSX.Element | null {
  const visible = METHOD_ORDER.filter(m => methods.includes(m));
  if (visible.length === 0) return null;
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-gray-500 border-b pb-2 mb-1">
      {visible.map(m => (
        <span key={m} className="flex items-center gap-1">
          <ServiceTypeMarker method={m} testId={`type-marker-legend-${m}`} />
          {METHOD_LABELS[m]}
        </span>
      ))}
    </div>
  );
}
